import React from 'react';
import { exportToCSV, exportToPDF } from '../../utils/exportUtils';

// Search box plus the CSV/PDF export dropdown shown above every data table.
const TableToolbar = ({ globalFilter, onGlobalFilterChange, dt, exportName, exportTitle, exportDisabled = false, extras = null, csvOnly = false, searchPlaceholder = 'Search...' }) => (
    <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
        <div className="relative w-full sm:w-64 max-w-xs">
            <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
            <input
                type="text"
                className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
                placeholder={searchPlaceholder}
                value={globalFilter}
                onChange={(e) => onGlobalFilterChange(e.target.value)}
            />
        </div>
        <div className="flex items-center gap-3 ml-auto">
            {extras}
            <div className="dropdown dropdown-end">
                <button type="button" className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full" disabled={exportDisabled}>
                    <i className="pi pi-file-export"></i> Export
                </button>
                <ul role="menu" tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                    <li><button type="button" onClick={() => exportToCSV(dt, exportName)}><i className="pi pi-file-excel text-success"></i> Download CSV</button></li>
                    {!csvOnly && (
                        <li><button type="button" onClick={() => exportToPDF(dt, exportName, exportTitle)}><i className="pi pi-file-pdf text-error"></i> Download PDF</button></li>
                    )}
                </ul>
            </div>
        </div>
    </div>
);

export default TableToolbar;
